/**
 *
 * LanguageModal
 *
 */

import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import Translate from '../../containers/Translate/Loadable';
import { AdaptiveButton } from '../AdaptiveElements';

export function LanguageModal({ languages, selectedLanguageCode, hideFn, setLanguage, transitionRef }) {
  const getLanguageClass = (lang) => classNames('lang-list-item', { selected: lang.code === selectedLanguageCode });

  return (
    <div className="modal-overlay" onClick={() => hideFn()} role="button" tabIndex={0} ref={transitionRef}>
      <div className="modal-body">
        <h2>
          <Translate message="langSelectTitlePre" />
        </h2>
        <h1>
          <Translate message="langSelectTitle" />
        </h1>
        {languages.map((lang) => (
          <AdaptiveButton
            className={getLanguageClass(lang)}
            onClick={() => setLanguage(lang)}
            type="button"
            tabIndex={0}
            key={lang.code}
            aria-label={lang.name}
          >
            <span className="lang-name">{lang.name}</span>
          </AdaptiveButton>
        ))}
      </div>
    </div>
  );
}

LanguageModal.propTypes = {
  languages: PropTypes.array.isRequired,
  selectedLanguageCode: PropTypes.string.isRequired,
  hideFn: PropTypes.func.isRequired,
  setLanguage: PropTypes.func.isRequired,
  transitionRef: PropTypes.object,
};

export default LanguageModal;
